<div class="custom-panel flex flex-grow">
    <mat-card class="flex flex-grow flex-column">
        <mat-card-header>
            <div fxLayout="row" fxLayoutAlign="space-between center" class="cst-panel-header pv-xxxs">
                <mat-card-title><h3>{{ header }}</h3></mat-card-title>
                <mat-card-subtitle *ngIf="subtitle !== ''" [innerHTML]="subtitle | safeHtml"></mat-card-subtitle>
                <div *ngIf="areButtons">
                    <div #ref>
                        <ng-content select="[panel-actions]"></ng-content>
                    </div>
                    <div *ngIf="ref.children.length == 0" fxLayout="row" fxLayoutAlign="flex-end center" fxLayoutGap="2px">
                        <button mat-button (click)="save()" class="upper cst-button-good" [disabled]="saveDisabled">{{ saveButtonText || "Zapisz" }}</button>
                        <button mat-button (click)="reset()" class="upper cst-button-bad" [disabled]="resetDisabled">{{ resetButtonText || "Odrzuć zmiany" }}</button>
                    </div>
                </div>
            </div>
        </mat-card-header>
        <mat-card-content>
            <ng-content select="[panel-body]"></ng-content>
        </mat-card-content>
    </mat-card>
</div>
